import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  getPaymentProviderLabel,
  getPaymentFormLabel,
  getPaymentRecordStatusLabel,
  type PaymentRecordDTO
} from '../../core/models';

@Component({
  selector: 'app-payment-read',
  templateUrl: './payment-read.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class PaymentReadComponent {
  payment = input.required<PaymentRecordDTO>();
  openSale = output<number>();

  readonly getPaymentFormLabel = getPaymentFormLabel;
  readonly getPaymentRecordStatusLabel = getPaymentRecordStatusLabel;
  readonly getPaymentProviderLabel = getPaymentProviderLabel;

  private readonly locale = typeof navigator !== 'undefined' ? navigator.language : undefined;

  openRelatedSale(): void {
    const saleId = this.payment().sale?.id;
    if (saleId != null) {
      this.openSale.emit(saleId);
    }
  }

  getCustomerName(payment: PaymentRecordDTO): string {
    const customer = payment.customer;
    if (!customer) return '-';
    return customer.comercialName || customer.legalName || customer.taxId || '-';
  }

  formatMoney(amount: number | undefined | null, currencyCode?: string | null): string {
    if (amount == null) return '-';
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    const code = currencyCode || 'MXN';
    return `${formatted} ${code}`;
  }

  formatDateTime(value: string | undefined | null): string {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString(this.locale);
  }

  metadataEntries(payment: PaymentRecordDTO): { key: string; value: string }[] {
    const metadata = payment.metadata;
    if (!metadata) return [];
    return Object.entries(metadata).map(([key, value]) => ({
      key,
      value: typeof value === 'string' ? value : JSON.stringify(value)
    }));
  }
}
